import strFunc from "@/lib/lyg/string";
import Style from "./css/style.module.css";

function BookListArea(props: any) {
  let myProps = {
    order_book_arr: [],
    set_order_book_arr: (inData: any) => { },
    is_order_online: false,
    ...props
  };

  const remove_book_by_seq=(inData:any)=>{
    let opt_obj={
      book_seq:"",
      ...inData
    };
    if(strFunc.is_empty(opt_obj.book_seq)){
      return false;
    }
    let new_book_arr:any=[];
    for(let i=0;i<myProps.order_book_arr.length;i++){
      let book_info=myProps.order_book_arr[i];
      if(book_info.a_seq!=opt_obj.book_seq){
        new_book_arr.push(book_info);
      }
    }
    myProps.set_order_book_arr(new_book_arr);
  };

  const get_book_list_tags = () => {
    let book_list_tags = myProps.order_book_arr.map((item: any, idx: number) => {
      let product_info = item.product_info;
      if(myProps.is_order_online){
        product_info=item.product_info_use;
      }
      let row_price = 0;
      if (product_info) {
        row_price = parseInt(strFunc.uncomma(product_info.a_price));
        row_price += parseInt(strFunc.uncomma(product_info.a_price_tax));
        row_price = strFunc.comma(row_price);
      }
      let type_str = "교재";
      if(myProps.is_order_online){
        type_str="온라인";
      }

      return (
        <div key={idx} className={Style.book_row}>
          <div className={Style.book_row_title}>
            {idx + 1}. {item.a_title}
            <span className="ml-1" style={{color:"#888"}}>({type_str})</span>
          </div>
          <div className={Style.book_row_price}>
            {row_price} 원
          </div>
          <div className={Style.book_row_manage}>
            <button className="btn btn-red" 
              onClick={()=>{
                remove_book_by_seq({book_seq:item.a_seq});
              }}>X</button>
          </div>
        </div>
      );
    });

    if(strFunc.is_empty(book_list_tags)){
      book_list_tags=(<div className="text-center" style={{lineHeight:"50px"}}>선택된 교재가 없습니다.</div>);
    }

    return book_list_tags;
  };

  return (
    <div className={Style.book_list_wrap}>
      {get_book_list_tags()}
    </div>
  );
};
export default BookListArea;